import React, { useState } from 'react'
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import Bid from './Bid';
import BidList from './Bidlist';
import TargetBidList from './TargetBidlist';
import FinalizeBidList from './FinalizeBidList';

const BidTenderManagement = () => {

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Tenders';
            case 2:
                return "Bid Tender List";
            case 3:
                return "Target Tender List";
            case 4:
                return "Final Tender List";
            case 5:
                return "Submitted Tender List";
            case 6:
                return "Rejected Tender List";
            default:
                return 'Tenders';
        }
    };

    return (
        <>
            <div>
                {/* <Dashboardnavbar name={getSelectedTitle()} url={"Tender"} showurl={'false'} /> */}


                <div className="content-tabs">

                    {toggleState === 1 ? <Bid /> : null}
                    {toggleState === 2 ? <BidList /> : null}
                    {toggleState === 3 ? <TargetBidList /> : null}
                    {toggleState === 4 ? <FinalizeBidList /> : null}

                </div>
            </div>

        </>
    )
}

export default BidTenderManagement
